<script setup>
import {RouterView, useRoute} from 'vue-router'
import {ref, watch} from "vue";
import LocaleSwitcher from "@/components/LocaleSwitcher.vue";
import BottomNav from "@/components/BottomNav.vue";
import logo from "@/assets/logo.svg";

const route = useRoute()
const main = ref(null)

// Every screen starts at the top, the shell itself never scrolls.
watch(() => route.fullPath, () => {
  if (main.value) {
    main.value.scrollTop = 0
  }
})
</script>

<template>
  <div class="app-frame">
    <div class="app-shell">
      <header class="app-header">
        <router-link :to="{name: 'booking.home'}" class="app-header__logo" aria-label="Wirtz World">
          <img :src="logo" alt="Wirtz World"/>
        </router-link>
        <locale-switcher/>
      </header>

      <main class="app-main ww-scroll" ref="main">
        <router-view v-slot="{ Component }">
          <transition name="ww-fade" mode="out-in">
            <component :is="Component"/>
          </transition>
        </router-view>
      </main>

      <bottom-nav/>
    </div>
  </div>
</template>
